import classes from "./HomeLayout.module.css";
import Sidenavbar from "../SharedComponents/Header/SideNavBar";

function Homelayout() {
  return (
    <div className={classes.HomeLayout_container}>
      {/* <SideNavbar setopen={setopen} open={open} /> */}
      {/* <NewSideBar /> */}
      <Sidenavbar />
    </div>
  );
}

export default Homelayout;
